import { useCallback, useState } from 'react';

export type VisibilityHandler = {
  show: VoidFunction;
  close: VoidFunction;
  visible: boolean;
  setVisible: ValueChanged<boolean>;
};

export const useVisible = (
  defaultValue: boolean = false,
  onChange?: ValueChanged<boolean>,
): VisibilityHandler => {
  const [visible, setVisibleInternal] = useState(defaultValue);

  const setVisible = useCallback(
    (isVisible: boolean) => {
      onChange?.(isVisible);
      setVisibleInternal(isVisible);
    },
    [onChange],
  );

  const show = () => setVisible(true);
  const close = () => setVisible(false);

  return {
    show,
    close,
    visible,
    setVisible,
  };
};
